import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202603",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 42126,
  clicks: 905,
  adsSpendDollars: 2725,
  budgetDollars: 4000,
  salesDollars: 15234,
  bestEstimateRoas: 5.59,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.68,
  newCustomersAcquired: 43,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
